<h3>Patientdetails</h3>

<patient-reminder patient="pmCtrl.patient"></patient-reminder>
<patient-current-drugs patient="pmCtrl.patient"></patient-current-drugs>
<patient-log patient="pmCtrl.patient"></patient-log>



